<v-container><v-row><v-col cols="6"></v-col><v-col cols="6"></v-col></v-row></v-container>